var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerF(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 294,
    viewBox: "0 0 164 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.792 5.39999C115.292 -8.58307e-06 98.7918 1.19999 86.4918 8.39999C75.3918 15 66.0918 27.3 61.2918 42.3C57.0918 54.9 54.9918 70.2 54.9918 86.1V139.2H0.691797V155.1H54.9918V294H70.8918V155.1H135.992V139.2H70.8918V86.1C70.8918 71.7 72.9918 58.2 76.2918 47.1C80.4918 35.7 86.7918 27.3 94.5918 22.2C102.992 17.1 113.192 16.2 122.492 20.1C138.392 26.4 143.492 43.8 147.392 64.2L163.292 61.2C159.092 39 151.292 14.7 128.792 5.39999Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerF);
export default __webpack_public_path__ + "static/media/LOWER_F.24c2e121d995180e406ac2faf5c28757.svg";
export { ForwardRef as ReactComponent };